import { render } from "./ModalEditDeliveryTime.vue?vue&type=template&id=637610e7&scoped=true"
import script from "./ModalEditDeliveryTime.vue?vue&type=script&lang=js"
export * from "./ModalEditDeliveryTime.vue?vue&type=script&lang=js"

import "./styles/ModalEditDeliveryTime.scss?vue&type=style&index=0&id=637610e7&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-637610e7"]])

export default __exports__